export interface BrandInfo {
  name: string;
  tagline: string;
  description: string;
  mission: string;
  vision: string;
  founded: string;
  address: string;
  phone: string;
  email: string;
  wechat: string;
  stats: { label: string; value: string }[];
  milestones: { year: string; title: string; description: string }[];
  team: { name: string; role: string; avatar: string; intro: string }[];
  testimonials: { name: string; age: string; city: string; content: string; avatar: string }[];
}

export const brandInfo: BrandInfo = {
  name: '老色哥',
  tagline: '成熟男人的穿搭圣经，品味男人的生活方式',
  description: '老色哥是国内领先的成熟男性穿搭风格与生活美学平台。我们汇聚了一群热爱生活、追求品质的资深穿搭达人和生活家，致力于为30-55岁的成熟男性提供最专业、最实用的穿搭指导和生活灵感。无论是经典绅士的西装穿搭、复古时尚的搭配技巧，还是雪茄、威士忌、腕表等生活美学的深度内容，老色哥都是您最值得信赖的指南。',
  mission: '帮助每一位成熟男性找到属于自己的风格，重拾自信，展现独特魅力。',
  vision: '成为中国最具影响力的成熟男性生活方式平台，让每一位中年男士都能活出属于自己的精彩。',
  founded: '2020年',
  address: '上海市静安区南京西路1788号世纪商贸广场18层',
  phone: '021-6288-8888',
  email: 'contact@laosege.com',
  wechat: '老色哥官方公众号',
  stats: [
    { label: '社区达人', value: '2,800+' },
    { label: '原创文章', value: '5,600+' },
    { label: '注册会员', value: '500,000+' },
    { label: '每日活跃', value: '80,000+' },
  ],
  milestones: [
    { year: '2020', title: '老色哥成立', description: '三位热爱穿搭的资深媒体人共同创立老色哥，专注成熟男性穿搭领域。' },
    { year: '2021', title: '社区突破10万会员', description: '凭借高质量的原创内容和深度穿搭分析，老色哥迅速积累10万忠实用户。' },
    { year: '2022', title: '推出\"老色哥达人计划\"', description: '邀请全国各地的穿搭达人入驻，打造中国最活跃的成熟男性穿搭社区。' },
    { year: '2023', title: '品牌升级', description: '从穿搭指南拓展为涵盖穿搭、生活美学、健康管理的全方位成熟男性生活方式平台。' },
    { year: '2024', title: '会员突破50万', description: '平台注册会员突破50万，成为中国成熟男性生活方式领域的领军品牌。' },
    { year: '2025', title: '国际化拓展', description: '开始与日本、韩国、意大利等国际男装品牌和媒体合作，为国内用户带来全球视野。' },
  ],
  team: [
    {
      name: '王志远',
      role: '联合创始人 & 主编',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Chinese%20man%20in%20his%2040s%20wearing%20a%20navy%20blazer%2C%20warm%20friendly%20expression%2C%20studio%20portrait%20with%20cream%20background&width=300&height=300&seq=team-wang&orientation=squarish',
      intro: '前《时尚先生》杂志资深编辑，拥有15年男装时尚行业经验，专注于经典绅士穿搭研究。',
    },
    {
      name: '陈建民',
      role: '联合创始人 & 创意总监',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20stylish%20Chinese%20man%20in%20his%2030s%20with%20tortoiseshell%20glasses%2C%20wearing%20a%20brown%20leather%20jacket%2C%20confident%20smile%2C%20studio%20portrait&width=300&height=300&seq=team-chen&orientation=squarish',
      intro: '知名生活方式博主，威士忌与雪茄品鉴师，擅长将生活美学与穿搭风格完美融合。',
    },
    {
      name: '李博文',
      role: '内容总监',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Chinese%20man%20in%20his%2040s%20with%20salt%20and%20pepper%20hair%2C%20wearing%20a%20casual%20linen%20shirt%2C%20studio%20portrait&width=300&height=300&seq=team-li&orientation=squarish',
      intro: '资深健康与生活方式作者，AFAA认证健身教练，专注于成熟男性健康管理与体态塑造。',
    },
  ],
  testimonials: [
    {
      name: '张伟明',
      age: '48岁',
      city: '北京',
      content: '自从关注老色哥以后，我的穿搭品味有了质的飞跃。以前总是随便穿穿就出门，现在同事们都说我越来越有范儿了。尤其是西装选择那篇文章，简直是我的穿搭圣经！',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20confident%20Chinese%20man%20in%20his%20late%2040s%20with%20a%20warm%20smile%2C%20wearing%20a%20grey%20suit%2C%20studio%20portrait&width=200&height=200&seq=testimonial-zhang&orientation=squarish',
    },
    {
      name: '刘建国',
      age: '52岁',
      city: '深圳',
      content: '老色哥不仅仅是一个穿搭平台，更是一个让中年男人重新找到自信的社区。在这里我学会了如何选择适合自己的手表和皮具，生活质量提升了很多。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Chinese%20man%20in%20his%2050s%20with%20silver%20hair%2C%20wearing%20a%20brown%20leather%20jacket%2C%20dignified%20expression%2C%20studio%20portrait&width=200&height=200&seq=testimonial-liu&orientation=squarish',
    },
    {
      name: '陈思远',
      age: '41岁',
      city: '上海',
      content: '以前觉得男人不用太讲究穿搭，是老色哥改变了我的想法。现在我每天出门前都会认真搭配，感觉整个人精气神都不一样了。推荐给每一位同龄男士！',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20modern%20Chinese%20man%20in%20his%20early%2040s%2C%20wearing%20a%20white%20shirt%2C%20friendly%20and%20approachable%2C%20studio%20portrait&width=200&height=200&seq=testimonial-chen&orientation=squarish',
    },
    {
      name: '赵大伟',
      age: '55岁',
      city: '广州',
      content: '老色哥的威士忌和雪茄品鉴内容非常专业，让我结交了很多志同道合的朋友。穿搭加生活美学的组合非常棒，这已经是我每天必看的平台了。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20sophisticated%20Chinese%20man%20in%20his%2050s%20with%20a%20cigar%2C%20confident%20and%20worldly%2C%20warm%20lighting%2C%20studio%20portrait&width=200&height=200&seq=testimonial-zhao&orientation=squarish',
    },
  ],
};